var $ = require('../../../../../../../webpack/node_modules/jquery');
var nunjucks = require('../../../../../../../webpack/node_modules/nunjucks');
require('../../../../../../../webpack/node_modules/jscroll');


if($('.tx-psr-sortenfinder').length && window.sortenfinderListPluginOnPage) {
	// require 3rd party modules
	const redux = require('redux')

	// require own modules
	const {configInitialState, ...config} = require('./config')
    const filter  = require('./filter')
    const view = require('./view')
	const pins = require('./pins')
	const getData = require('./getData')

	/**
	 * initial
	 * redux store state
	 *
	 */
    const initialState = {
    	// initial states defined in other modules
        ...configInitialState,
        ...filter.initialState,
	    ...view.initialState,
		// config
	    config,
		// language
		lang: document.documentElement.lang || configInitialState.lang,
		ce: window.ce,
		sourceTarget: window.sourceTarget,
		// uris
	    detailUri : window.detailUri,
	    memoUri : window.memoUri,
        sustainerUri : window.sustainerUri,
		jsonUri: window.jsonUri,

		// various label set in plugin html
        searchLabel : window.searchLabel,
        searchTextSingular:window.searchTextSingular,
        searchTextPlural:window.searchTextPlural,
        searchTitle: window.searchTitle,
        loginStatus : window.loginStatus,
        alertMessageStringAdd : window.alertMessageStringAdd,
        alertMessageStringRemove: window.alertMessageStringRemove,
        filterLabel : window.filterLabel,
        filterBySubLabel: window.filterBySubLabel,
        filterBySubSubLabel: window.filterBySubSubLabel,
        filterByDropdown: window.filterByDropdown,
        sustainerMissing : window.sustainerMissing,
        becomeSustainer: window.becomeSustainer,
        orderActive : window.orderActive,
        commercialOffer : window.commercialOffer,
        details: window.details,
        label : window.label,
        hideOrderDetails: parseInt(window.hideOrderDetails),
    }

    // reducers to update state after actions have been dispatched
	const reducers = {
		...filter.reducers,
		...view.reducers,
		init: (state, action) => {return {...state,  config: action.data}}
	}

	// reducer
	// only dalegates action
	// if action.type is found in reducers constant above
	// call the respective reducer function
	// if not simply return the state as it is
	// only one reducer per action.type is  possible
	const reducer = (state = initialState, action = null) => {
		return reducers[action.type] ? reducers[action.type](state, action) : state
	}
	/**
	 * create redux state
	 * https://redux.js.org/introduction/getting-started
	 */
	const store = redux.createStore(reducer)

	// init other modules
    view.init(store)
    filter.init(store)

	// dispatch init event, with config as data
	store.dispatch({type: 'init', data: config})

	// load items json
	const loadItems = (uri, repeat) => {
		if(repeat > 1) {
			return
		}

		getData.loadData(uri, store.getState().lang, store.getState().ce, store.getState().sourceTarget)
			.then(response => {
				store.dispatch({type: 'initItems', data: response.content})
			})
	}

	loadItems(store.getState().jsonUri, 0)


	// add event listeners
    $('.sortenfinder-filter').on('click', 'button:not(.search-field-button)', (event) => {
        const filter = $(event.target).closest('button').data('filter')
        store.dispatch({type: 'filter', data: {filterKey: filter, value: true}})
    })
    $('.sortenfinder-filter').on('click', '.reset-link', (event) => {
	    store.dispatch({type: 'resetFilter', data: true})
	    return false
    })
    $('.sortenfinder-filter').on('click', '.extended-filter-trigger-container', (event) => {
	    store.dispatch({type: 'extendedFilterToggle', data: true})
	    return false
    })
    $('.sortenfinder-filter').on('change', 'select', (event) => {
	    const filter = $(event.target).data('filter')
	    const value = $(event.target).val()
	    store.dispatch({type: 'filter', data: {filterKey: filter, value: value}})
    })
    $('.sortenfinder-filter').on('keyup', 'input', (event) => {
        if(event.originalEvent.keyCode === 13) {
		    store.dispatch({type: 'filter', data: {filterKey: 'text', value: $(event.target).val()}})
	    }
    })
    $('.sortenfinder-filter').on('click', 'button.search-field-button', (event) => {
        const value = $('.sortenfinder-filter').find('input.search-field-input').val()
	    store.dispatch({type: 'filter', data: {filterKey: 'text', value: value}})
    })
    $(window).on('scroll', function() {
	    if($('.sortenfinder-list__contents')[0].getBoundingClientRect().bottom - window.innerHeight <  100){
		    store.dispatch({ type: 'pagination', value: 'next'})
	    }
    });
}
